import { UploadFile } from 'ngx-uploader';

export interface UploadFileWithMeta extends UploadFile {
  meta?: {
    bucket_url: string;
    bucket_key: string;
    bucket_filename: string;
    download_url: string;
    url: string;
  };
}

export interface UploadedFileWithMeta {
  file: UploadFileWithMeta;
  url: string;
}

/**
 * @description: Always ensure there is a slash between the url and the bucket key.
 * This is due to localstack needing "path" address style vs live using "virtual" address style.
 * This functionality should be moved to the bo-angular packages in future
 * @param {UploadFile} file
 * @return {*}
 */

export function returnSlashedPath(file: UploadFileWithMeta): string {
  if (file.meta?.url.endsWith('/')) {
    return file.meta?.url + file.meta.bucket_key;
  } else {
    return `${file.meta?.url}/${file.meta?.bucket_key}`;
  }
}

export function returnDownloadUrl(file: UploadFileWithMeta): string | undefined {
  return file.meta?.download_url;
}
